module.exports = __webpack_public_path__ + "static/media/blueprint.b1a52c0f.png";